"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.schedule.date': 'Data pubblicazione',
    'socialMediaPlan.schedule.time': 'Ora',
    'socialMediaPlan.schedule.summary': 'Riepilogo',
    'socialMediaPlan.schedule.draftTitle': 'Bozza',
    'socialMediaPlan.schedule.draftDesc': 'Salva come bozza',
    'socialMediaPlan.schedule.reviewTitle': 'Revisione',
    'socialMediaPlan.schedule.reviewDesc': 'Richiedi revisione',
    'socialMediaPlan.schedule.scheduledTitle': 'Programmato',
    'socialMediaPlan.schedule.scheduledDesc': 'Programma per dopo',
    'socialMediaPlan.schedule.publishedTitle': 'Pubblicato',
    'socialMediaPlan.schedule.publishedDesc': 'Pubblica ora',
};
